import axiosConfig from "../app/axiosConfig"
import {
  DOWNLOAD_BANK_STATEMENT_API,
  LAST_UPLOAD_LOG_API,
  UPLOAD_HISTORY_LIST_API,
} from "../constants/apis"
import {
  fetchBankStatementPayloadType,
  fetchuploadHistoryPayloadType,
  fetchuploadLogPayloadType,
} from "../slices/uploadHistorySlice"
import { computeRoute } from "../utils/compute-route"

export const fetchUploadHistoryService = ({
  payload,
}: fetchuploadHistoryPayloadType) => {
  return axiosConfig.get(UPLOAD_HISTORY_LIST_API, {
    params: {
      page_size: payload.pageSize,
      page_no: payload.page + 1,
      ...(payload.bankAccountId && { bank_account_id: payload.bankAccountId }),
      ...(payload.status && { status: payload.status }),
      ...(payload.sortBy && { sort_by: payload.sortBy }),
      ...(payload.orderBy && { order_by: payload.orderBy }),
    },
  })
}

export const fetchUploadLogService = ({
  payload,
}: fetchuploadLogPayloadType) => {
  const params = payload.bankAccountId
    ? { bank_account_id: payload.bankAccountId }
    : {}
  return axiosConfig.get(LAST_UPLOAD_LOG_API, {
    params,
  })
}

export const downloadBankStatementFileService = ({
  payload,
}: fetchBankStatementPayloadType) => {
  return axiosConfig.get(
    computeRoute(DOWNLOAD_BANK_STATEMENT_API, {
      accountId: payload.id,
    }),
    {
      responseType: "blob",
    },
  )
}
